document.querySelectorAll('.product-block--tab').forEach(block => {
    const inner = block.querySelector('.collapsible-content__inner');
    if (!inner) {
      return;
    }
    if (inner.innerHTML.trim() === '') {
      block.style.display = 'none';
    }
});

function addLastUrlSegmentAsBodyClass() {
  // Get path from current URL
  const path = window.location.pathname;

  // Split path by "/" and remove empty values
  const parts = path.split('/').filter(Boolean);

  // Get last segment
  const lastSegment = parts[parts.length - 1];

  if (lastSegment) {
    document.body.classList.add(lastSegment);
  }
}

function checkBodyClassAndUpdateHeader(classArray) {
  // Check if body has any of the classes
  const hasMatch = classArray.some(cls => document.body.classList.contains(cls));

  if (hasMatch) {
    document.body.classList.add('custom-header');
    const header = document.querySelector('.header-wrapper');
    const siteHeader = document.querySelector('.site-header');

    if (header && siteHeader) {
      header.classList.add('header-wrapper--overlay', 'is-light');
      siteHeader.setAttribute("data-overlay", hasMatch);

      // Add scroll event
      window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY || window.pageYOffset;
        const headerHeight = header.offsetHeight;

        if (scrollTop > headerHeight) {
          header.classList.add("header-wrapper--sticky");
        } else {
          header.classList.remove("header-wrapper--sticky");
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  addLastUrlSegmentAsBodyClass();

  checkBodyClassAndUpdateHeader(["about", "our-stores"]);
});

document.addEventListener('DOMContentLoaded', () => {
  const addToCart = document.querySelector('[data-add-to-cart]');
  const addToCartText = document.querySelector('[data-add-to-cart-text]');
  const incomingInventory = document.querySelector('[data-incoming-inventory]');

  function updateButton() {
    if (!addToCart || !addToCartText || !incomingInventory) return;

    if (!incomingInventory.classList.contains('hide')) {
      // backorder / pre-order
      addToCart.disabled = false;
      addToCartText.textContent = 'Pre-order';
    } else {
      addToCartText.textContent = 'Add to cart';
    }
  }

  updateButton();

  const select = document.querySelector('select[name="id"]');
  if (select) {
    select.addEventListener('change', updateButton);
  }
});

